import React, {Component} from 'react';
import SecureLayout from "./secure";
import _ from "lodash";
import GobLogo from '../assets/images/gobmxlogo.svg';
import Notification from './../elements/notification';
import Navigation from "../elements/navigation/navigation";
import UserDropdown from "../elements/user-opts-dropdown";
import ReportsSubnav from "../elements/navigation/reports-subnav";
import {reportsInitNav} from "../store/config";
import ProjectNavigation from "../elements/navigation/project-navigation";

export default function (SecuredComponent, data) {
	class ReportsLayout extends Component {
		render() {
			const {userLogin, notifications, match, location, session, menu} = this.props;
			let { agencies } = session.user;
			let agency = this.setAgencyName(match.params.modality, agencies);
			return [
				<Navigation agencies={{...agencies}} cdms={{...session.user.cdms}} items={{...session.user.menu}} show={menu.view} location={{...location}} key={`app-navigation-sidebar`} />,

				<div className="project-content" key="project-website-content">
					<nav className="navbar is-dark secondary-navigation">
						<div className="navbar-menu navbar-item">
							<img src={GobLogo} alt="gob.mx" className="app-gov-logo--image" />
						</div>

						{session.user.version ?
							<div className="navbar-menu navbar-item">
								<h6 className="title is-6 has-text-centered has-text-white">{session.user.version.name}</h6>
							</div>:''}

						<button className="main-nav--close" onClick={() => this.toggleMenu()}>
							{menu.view ? <i className="fa fa-chevron-left" /> : <i className="fa fa-chevron-right" />}
						</button>
						<UserDropdown data={{...session.user.profile}} />
					</nav>

					<ProjectNavigation
						isFetching={userLogin.isFetching}
						filter={this.state.filterType}
						filterChange={this.filterChange}
						modality={match.params.modality}
						entity={match.params.state}
						agencies={agencies}
						municipalityFilter={this.municipalityFilter}
						municipalityChange={this.municipalityChange}
						stateChange={this.stateChange}
						agenciable={{state:this.state.modState, municipality:match.params.municipality}}
					/>

					<ReportsSubnav
						step={data.subnav}
						params={match.params}
						agency={agency}
						reports={this.props.reports}
					/>

					<section className="app-layout--content" style={{padding: '0rem 0rem'}}>
						<h1 className="title is-1 main-title" dangerouslySetInnerHTML={{__html: _.find(reportsInitNav,{step:data.subnav}).title}}></h1>

						{notifications.data.title &&
							<div className="columns is-centered">
								<div className="column is-10-desktop">
									<Notification {...notifications} />
								</div>
							</div>}

						<div className="app-container">
							<SecuredComponent {...this.props} />
						</div>
					</section>
				</div>
			]
		}

		constructor(props) {
			super();
			this.state = {
				modState: props.match.params.state,
				filterType: 'all_projects'
			}
			this.municipalityFilter = this.municipalityFilter.bind(this);
			this.municipalityChange = this.municipalityChange.bind(this);
			this.stateChange = this.stateChange.bind(this);
			this.toggleMenu = this.toggleMenu.bind(this);
			this.filterChange = this.filterChange.bind(this);
		}

		toggleMenu() {
			let { view } = this.props.menu;
			return view === true ? this.props.hideMenu() : this.props.showMenu();
		}

		filterChange(e){
			return this.setState({
				filterType: e.target.value
			})
		}

		stateChange(state) {
			let url = _.split(this.props.location.pathname, '/', 5);
			url[4] = state;
			url = _.join(url, '/');
			return this.props.history.push(url);
		}

		municipalityFilter(state) {
			return this.setState({
				modState: state
			});
		}

		municipalityChange(municipality) {
			let url = _.split(this.props.location.pathname, '/', 6);
			url[4] = this.state.modState;
			url[5] = municipality;
			url = _.join(url, '/');
			return this.props.history.push(url);
		}

		setAgencyName(mod, agencies) {
			let {state, municipality} = this.props.match.params;
			let agency = undefined;
			if(!_.isEmpty(agencies)) {
				switch(mod) {
					case 'modalidad-i':
						agency = _.find(agencies['modalidad-i'], {agenciable_short:state});
						return !_.isEmpty(agency) && agency.agenciable_name;
					case 'modalidad-ii':
						agency = _.find(agencies['modalidad-ii'], {agenciable_slug:municipality});
						return !_.isEmpty(agency) && agency.agenciable_name;
					case 'modalidad-iii':
						agency = _.find(agencies['modalidad-iii'], {agenciable_short:state});
						return !_.isEmpty(agency) && agency.agenciable_name;
					default:
						return undefined;
				}
			}else{
				return null;
			}
		}
	}

	return SecureLayout(ReportsLayout);
}



// WEBPACK FOOTER //
// ./src/templates/reports.jsx